<script>
	/*
		TCareSelect.svelte
	*/

	export let source;
	export let prop;
	export let setValue;
	export let options;
	export let value;

	const _onClick = () => {
		setValue(source, prop, value);
	}

</script>

<style>
</style>

<div class="tcui-control flex-row" on:click={_onClick}>
	<select class="select">
		<option value=""></option>
		{#each options as option}
			<option value={option.value}>{option.label}</option>			
		{/each}
	</select>
</div>

